/**
 * "The person's apps changed": ONE signal, ONE name.
 *
 * Measured on cloch, 6 Oct 2026: Maria connected Xero in chat at 09:58Z and her Apps tree stayed
 * stale until she reloaded the page. The tree read its lists once, on mount. The only thing that
 * ever told it to look again was `command:apps-changed`, fired from one place (the API-key card),
 * so a sign-in settled by the connect card, a database connected or removed, and a held
 * connection removed all left it showing yesterday's list.
 *
 * Every place that makes, revives, reconnects or removes a connection announces it here, and
 * every surface that lists apps listens here. The event carries nothing: a listener re-reads its
 * own source, so a stale payload can never stand in for the truth.
 */

export const APPS_CHANGED_EVENT = "command:apps-changed";

export function announceAppsChanged(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.dispatchEvent(new Event(APPS_CHANGED_EVENT));
}
